<footer id="footer-container" class="fixed-bottom">
    <div class="d-flex flex-row justify-content-between align-items-center ms-4">
        <div>
            <span>&copy; {{year}} Protiviti Inc. All Rights Reserved.</span>
        </div>
        <div>
            <div id="chat4">
                <div (click)="changeShowHelp()" [style.height.px]="footerHeight" class="help-section">
                    <fa-icon class="help-icon" [icon]="faQuestionCircle"></fa-icon>
                </div>
            </div>
            <div id="chat1" class="help-options">
                <div [hidden]="!showHelpMenu" class="help-menu">
                    <div class="option" (mouseover)="faqHover = true" (mouseleave)="faqHover = false" 
                        [ngStyle]="{backgroundColor: faqHover === true ? '#f6871f' : '#1AA2BC' }">
                        <a href="https://roberthalf.sharepoint.com/sites/iShare-iManage/Shared Documents/Forms/AllItems.aspx?id=%2fsites%2fiShare-iManage%2fShared Documents%2fiManage FAQs%2Epdf&parent=%2fsites%2fiShare-iManage%2fShared Documents" target="_blank">
                            <fa-icon class="font-white text-decoration-none mt-1 me-2" [icon]="faFileText"></fa-icon>
                            <span class="font-white ms-1">iManage FAQs</span>
                        </a>
                    </div>
                    <hr />
                    <div class="option" (mouseover)="iShareHover = true" (mouseleave)="iShareHover = false" 
                        [ngStyle]="{backgroundColor: iShareHover === true  ? '#f6871f' : '#1AA2BC' }" >
                        <a href="https://roberthalf.sharepoint.com/sites/iShare-iManage" target="_blank">
                            <fa-icon class="font-white text-decoration-none mt-1 me-2" [icon]="faSiteMap"></fa-icon>
                            <span class="font-white ms-1">iManage iShare Site</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>